import React from 'react';

export const imageHooks = {
  useImageSrc(src: string | { src: string } | undefined) {
    return React.useMemo(() => typeof src === 'string'
      ? src : src?.src, [src]);
  },
};
